import { Button } from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

const UploadButton = ({ handleOpen }: { handleOpen: () => void }) => {
	return (
		<div>
			<label htmlFor="contained-button-file">
				<Button
					variant="contained"
					className="button-green"
					style={{ color: "#512B81", backgroundColor: "#f2ecf9" }}
					component="span"
					startIcon={<CloudUploadIcon />}
					onClick={handleOpen}
				>
					Upload Document
				</Button>
			</label>
		</div>
	);
};

export default UploadButton;
